import { ChartGraphicOrganizerBehavior } from './ChartGraphicOrganizerBehavior';

export class TChartBehavior extends ChartGraphicOrganizerBehavior {
  // placeholder
}

export default new TChartBehavior();
